import { Box } from "@prismicio/editor-ui"
import { Suspense } from "react"

import {
  headerBottomMargin,
  SidePanel,
  sidePanelPadding
} from "../documentLayout"
import { PreviewMenu } from "./PreviewMenu"
import { SliceTable } from "./sliceTable/SliceTable"

export function LeftSidePanel() {
  return (
    <SidePanel>
      <Suspense>
        <Box
          flexGrow={1}
          overflowY="auto"
          position="relative"
          flexDirection="column"
          padding={{ top: headerBottomMargin, ...sidePanelPadding("left") }}
        >
          <SliceTable />
        </Box>

        <Box
          flexDirection="column"
          padding={{ ...sidePanelPadding("left"), bottom: 24 }}
        >
          <Suspense>
            <PreviewMenu />
          </Suspense>
        </Box>
      </Suspense>
    </SidePanel>
  )
}
